import type { ReactNode } from 'react';

export function MetricCard({
  label,
  value,
  hint,
  icon,
}: {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <div className="card p-5">
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium uppercase tracking-wide text-ink-500 dark:text-ink-400">
          {label}
        </span>
        {icon && <span className="text-ink-400 dark:text-ink-500">{icon}</span>}
      </div>
      <div className="mt-3 text-3xl font-semibold text-ink-900 dark:text-ink-50 tracking-tight">
        {value}
      </div>
      {hint && <div className="mt-1 text-xs text-ink-500 dark:text-ink-400">{hint}</div>}
    </div>
  );
}
